<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "InformasiRedeemProduk",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
